import { ChangeEventHandler, type JSX } from 'react';
import { FormFieldPropsBase } from "../form/Form";
import FormSelect from "../form-select/FormSelect";
import i18n from "../../../services/localization-service/i18n";
import { IKeyValuePair } from "../../../common/models/KeyValuePair";
import { Box, MenuItem } from '@mui/material';

const COLOR_TRANLSATION_KEYS = [
    "AliceBlue", "AntiqueWhite", "Aqua", "Aquamarine", "Azure", "Beige",
    "Bisque", "Black", "BlanchedAlmond", "Blue", "BlueViolet", "Brown", "BurlyWood",
    "CadetBlue", "Chartreuse", "Chocolate", "Coral", "CornflowerBlue", "Cornsilk", "Crimson",
    "Cyan", "DarkBlue", "DarkCyan", "DarkGoldenrod", "DarkGray", "DarkGreen", "DarkKhaki",
    "DarkMagenta", "DarkOliveGreen", "DarkOrange", "DarkOrchid", "DarkRed", "DarkSalmon",
    "DarkSeaGreen", "DarkSlateBlue", "DarkSlateGray", "DarkTurquoise", "DarkViolet",
    "DeepPink", "DeepSkyBlue", "DimGray", "DodgerBlue", "Firebrick", "FloralWhite",
    "ForestGreen", "Fuchsia", "Gainsboro", "GhostWhite", "Gold", "Goldenrod", "Gray", "Green",
    "GreenYellow", "Honeydew", "HotPink", "IndianRed", "Indigo", "Ivory", "Khaki", "Lavender",
    "LavenderBlush", "LawnGreen", "LemonChiffon", "LightBlue", "LightCoral", "LightCyan",
    "LightGoldenrodYellow", "LightGray", "LightGreen", "LightPink", "LightSalmon",
    "LightSeaGreen", "LightSkyBlue", "LightSlateGray", "LightSteelBlue", "LightYellow", "Lime",
    "LimeGreen", "Linen", "Magenta", "Maroon", "MediumAquamarine", "MediumBlue",
    "MediumOrchid", "MediumPurple", "MediumSeaGreen", "MediumSlateBlue", "MediumSpringGreen",
    "MediumTurquoise", "MediumVioletRed", "MidnightBlue", "MintCream", "MistyRose", "Moccasin",
    "NavajoWhite", "Navy", "OldLace", "Olive", "OliveDrab", "Orange", "OrangeRed", "Orchid",
    "PaleGoldenrod", "PaleGreen", "PaleTurquoise", "PaleVioletRed", "PapayaWhip", "PeachPuff",
    "Peru", "Pink", "Plum", "PowderBlue", "Purple", "Red", "RosyBrown", "RoyalBlue",
    "SaddleBrown", "Salmon", "SandyBrown", "SeaGreen", "SeaShell", "Sienna", "Silver",
    "SkyBlue", "SlateBlue", "SlateGray", "Snow", "SpringGreen", "SteelBlue", "Tan", "Teal",
    "Thistle", "Tomato", "Turquoise", "Violet", "Wheat", "White", "WhiteSmoke", "Yellow",
    "YellowGreen", "Empty"
];

const colors = COLOR_TRANLSATION_KEYS.map(o => {
    const item: IKeyValuePair<string, string> = {
        Key: o,
        Value: i18n.t(`colors.${o}`)
    };

    return item;

});


export type FormColorPickerProps = {
    rules?: any;
    size?: "small" | "medium" | undefined;
    boldOnDirty?: boolean;
    onChanging?: (toValue: string | number, fromValue: string | number) => Promise<boolean>;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
} & FormFieldPropsBase;

export default function FormColorPicker({
    name,
    id,
    testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    rules,
    sx,
    disabled,
    size,
    boldOnDirty,
    onChanging,
    onChange
}: FormColorPickerProps): JSX.Element {


    const rectangle = (color: string) => <Box component="div" sx={{ display: 'flex', 
    //flex: '0 0 auto', 
    marginTop: 'auto',
    marginBottom: 'auto',
    bgcolor: color, 
    width: 16, 
    height: 16 }} />;


    return (
        <FormSelect
            name={name}
            id={id}
            testId={testId}

            label={label}
            ariaLabel={ariaLabel}
            readOnly={readOnly}
            helperText={helperText}
            rules={rules}
            sx={sx}
            disabled={disabled}
            size={size}
            boldOnDirty={boldOnDirty}
            onChanging={onChanging}
            onChange={onChange}
        >
            {
            colors.map(o => 
                <MenuItem key={o.Key} value={o.Key}>
                    <Box
                        sx={{
                            display: 'flex',
                            flex: '1 1 auto',
                            justifyContent: 'space-between'
                        }}>
                        <Box>
                            {o.Value}
                        </Box>
                        {rectangle(o.Key)}                                        
                    </Box>
                </MenuItem>
            )
            }
        </FormSelect>
    );
}